"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "brunico": {
    "8355f2b9": [{
      "hkey": "06db48e0",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "brunico": [{
      "hkey": "06db48e0",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "404ee889": [{
      "hkey": "06db48e0",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "stegona": [{
      "hkey": "06db48e0",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "brunico"
    }],
    "1639f580": [{
      "hkey": "cfee81f3",
      "slug": "teodone",
      "name": "Teodone",
      "primary": true,
      "skipSearch": false
    }],
    "tendone": [{
      "hkey": "cfee81f3",
      "slug": "teodone",
      "name": "Teodone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;